/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import { Form, Header, Tab } from '@mairistem/composants';

interface TabParametreProps {
  title: string;
  children: React.ReactNode;
}

const TabParametre = (props: TabParametreProps) => {
  const { title, children } = props;

  return (
    <Tab.Pane>
      <Header>{title}</Header>
      {/* @ts-expect-error style */}
      <Form style={{ padding: '0 2em' }}>{children}</Form>
    </Tab.Pane>
  );
};

export default TabParametre;
